<template>
  <div class="contact-page container mt-5 pt-4">
    <h2 class="mb-4 text-primary">Contact Us</h2>
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="mb-3">
        <label for="name" class="form-label">Full Name</label>
        <input type="text" class="form-control" v-model="form.name" required />
      </div>

      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input type="email" class="form-control" v-model="form.email" required />
      </div>

      <div class="mb-3">
        <label for="message" class="form-label">Message</label>
        <textarea class="form-control" v-model="form.message" rows="5" required></textarea>
      </div>

      <button type="submit" class="btn btn-primary">Send Message</button>
    </form>
  </div>
</template>

<script setup>
import { ref } from "vue";

const form = ref({ name: "", email: "", message: "" });

const submitForm = () => {
  alert(`Message sent!\nName: ${form.value.name}\nEmail: ${form.value.email}`);
  form.value = { name: "", email: "", message: "" };
};
</script>
